import { createApp } from 'vue'

createApp(App).mount('#app')

import Vue from "vue";
import App from "./App.vue";



//import router from "./router";
//import firebase from "firebase";
//import { initializeApp } from "firebase/app";
//import { getAuth } from "firebase/auth";

//import { getAuth } from "firebase/auth";

/*const provider = new GoogleAuthProvider();

const app = initializeApp(firebaseConfig);

const firebaseConfig = {
    apiKey: "AIzaSyAB8ajEH-dDoMUalEhzcU_SV6NJL59Ah5I",
    authDomain: "erfc-167e3.firebaseapp.com",
    databaseURL: "https://erfc-167e3-default-rtdb.firebaseio.com",
    projectId: "erfc-167e3",
    storageBucket: "erfc-167e3.appspot.com",
    messagingSenderId: "1058916923161",
    appId: "1:1058916923161:web:5ac81b720a35322bb9b788",
    measurementId: "G-8MXJX9CRJG"
  };


  // Initialize Firebase
// Initialize Firebase




const auth = getAuth();
auth.languageCode = 'it';
// To apply the default browser preference instead of explicitly setting it.
// firebase.auth().useDeviceLanguage();

Vue.config.productionTip = false;
*/

//import { GoogleAuthProvider } from "firebase/auth";

//const provider = new GoogleAuthProvider();

//provider.addScope('https://www.googleapis.com/auth/contacts.readonly');

//import { getAuth } from "firebase/auth";

//const auth = getAuth();
//auth.languageCode = 'it';
// To apply the default browser preference instead of explicitly setting it.
// firebase.auth().useDeviceLanguage();

new Vue({
  //router,
  render: h => h(App)
}).$mount("#app");